import * as React from "react";
import { cn } from "lib/utils"; // or your own class merge

type Variant = "block" | "text" | "avatar" | "chip";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** visual shape helper; you can still override via className */
  variant?: Variant;
  /** shimmer uses your .loading-shimmer; pulse uses .loading-skeleton */
  animation?: "shimmer" | "pulse" | "none";
}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ variant = "block", animation = "shimmer", className, ...props }, ref) => {
    // map your utilities
    const base =
      animation === "none"
        ? ""
        : animation === "pulse"
        ? "loading-skeleton"
        : "loading-shimmer";

    const shape =
      variant === "text"
        ? "skeleton-text" // height handled inside class
        : variant === "avatar"
        ? "skeleton-avatar"
        : variant === "chip"
        ? "rounded-full"
        : "rounded"; // block

    return <div ref={ref} className={cn(base, shape, className)} {...props} />;
  }
);
Skeleton.displayName = "Skeleton";
